import jsPDF from "jspdf";
import { DateTime } from "luxon";

/**
 * Generates a PDF containing appointments with Order Form Notes
 * that fall within the provided date range.
 *
 * @param {Array} appointments - The list of appointments (already filtered by other criteria).
 * @param {DateTime} viewStart - The start date of the export range.
 * @param {DateTime} viewEnd - The end date of the export range.
 */
export const generateOrderFormNotesPDF = (appointments, viewStart, viewEnd) => {
  // Filter for appointments with orderFormNotes and that fall within the export range
  const filteredAppointments = appointments.filter((appt) => {
    if (!appt.orderFormNotes || !appt.orderFormNotes.trim()) return false;
    const apptDate = DateTime.fromISO(appt.appointmentDate);
    return apptDate >= viewStart && apptDate <= viewEnd;
  });

  if (filteredAppointments.length === 0) {
    alert("No appointments with Order Form Notes found in the selected date range.");
    return;
  }

  const doc = new jsPDF();

  // Header
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("Appointments with Order Form Notes", 14, 20);
  doc.setLineWidth(0.5);
  doc.line(14, 22, 196, 22); // Underline

  let yPosition = 30;
  const lineSpacing = 8;
  const sectionSpacing = 12;
  const textWrapWidth = 180;
  const pageMargin = 270;

  filteredAppointments.forEach((appt, index) => {
    if (yPosition > pageMargin) {
      doc.addPage();
      yPosition = 20;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("Appointments with Order Form Notes (Continued)", 14, yPosition);
      doc.line(14, yPosition + 2, 196, yPosition + 2);
      yPosition += sectionSpacing;
    }

    const formattedDate = appt.appointmentDate
      ? DateTime.fromISO(appt.appointmentDate).toFormat("MM-dd-yyyy")
      : "No Date";

    // Title: Client Name
    doc.setFont("helvetica", "bold");
    doc.text(`${index + 1}. ${appt.client}`, 14, yPosition);
    yPosition += lineSpacing;

    // Date Field
    doc.setFont("helvetica", "normal");
    doc.text(`Date: ${formattedDate}`, 14, yPosition);
    yPosition += lineSpacing;

    // Wrap Notes Properly
    const wrappedNotes = doc.splitTextToSize(`Notes: ${appt.orderFormNotes}`, textWrapWidth);
    doc.text(wrappedNotes, 14, yPosition);
    yPosition += wrappedNotes.length * lineSpacing + sectionSpacing;
  });

  doc.save("Appointments_With_OrderFormNotes.pdf");
};
